import authApi from '../auth/authApi';
import axios, { AxiosRequestConfig } from 'axios';

export interface BackendApiOptions {
  url: string;
  method: 'get' | 'post' | 'patch';
  query?: { [key: string]: unknown };
  data?: unknown;
  responseType?: string;
}

export async function request(options: BackendApiOptions) {
  const axiosOptions: AxiosRequestConfig = {
    ...getDefaultOptions(),
    url: options.url,
    method: options.method,
    params: options.query,
    data: options.data,
    responseType: options.responseType,
  };
  return await axios(axiosOptions);
}

function getDefaultOptions() {
  const authorization = authApi.getAuthHeader();
  return {
    headers: {
      authorization,
    },
  };
}

export default {
  request,
};
